export const __prod__ = process.env.NODE_ENV === 'production';

export const PAGE_INDEX = 0;
export const PAGE_SIZE = 22;
export const PAGE_SIZE_15 = 15;

export enum SEARCH_PARAM {
  WEB_IN_APP = 'webinapp',
  TOKEN = 'token',
  LAT = 'lat',
  LNG = 'lng',
}

export enum WEB_IN_APP_ID {
  AHAMOVE_WEB = 'w_ahamove',
  AHAMOVE_MOBILE = 'ahamove',
}

export enum WEB_IN_APP_EVENT {
  CLOSE = 'close',
  BACK = 'back',
  HIDE_TOOLBAR = 'hide_toolbar',
  GET_TOKEN = 'getToken',
  OPEN_PAGE = 'openPage',
}

export const IN_APP_SCREEN = {
  balance: `ahamove://balance?open_topup=true`,
  records: `ahamove://records`,
  orderDetail: (orderId: string) =>
    `ahamove://order_detail?pay_now=true&order_id=${orderId}`,
};

export const FORCE_PAY_BY_BALANCE_STORE_IDS = [10717, 11165];

export enum ITEM_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
